import { withPageLayout } from 'acscp/components/layout/pageLayout';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AppState } from 'acscp/store';
import { connect } from 'react-redux';
import { FullPageMessage, FullPageMessageGoToMyChartersButton } from 'acscp/components/common/fullPageMessage';
import backgroundStyle from 'acscp/styles/containerBackgrounds.module.scss';

interface FlightRequestSubmittedPageStateProps {
    hasAccountManager: boolean;
}

type FlightRequestSubmittedPageProps = FlightRequestSubmittedPageStateProps;

export const FlightRequestSubmittedPagePresentational: React.FC<FlightRequestSubmittedPageProps> = props => (
            <FullPageMessage
                title={
                    <FormattedMessage
                        id={'components.flightRequest.form.confirmationThankYouTitle'}
                        defaultMessage={'Thank You'}
                    />}
                message={props.hasAccountManager
                    ? (
                        <FormattedMessage
                            id={'components.flightRequest.form.confirmationThankYouMessage'}
                            defaultMessage={'Your Account Manager will contact you shortly.'}
                        />
                    ) : (
                        <FormattedMessage
                            id={'components.flightRequest.form.confirmationThankYouMessageWithoutAccountManager'}
                            defaultMessage={'One of our Account Managers will contact you shortly.'}
                        />
                    )
                }
                buttons={FullPageMessageGoToMyChartersButton}
                containerClassName={backgroundStyle.CloudBackground}
            />
        );

function mapStateToProps(state: AppState, ownProps: {}): FlightRequestSubmittedPageStateProps {
    return {
        hasAccountManager: !!state.broker.broker
    };
}

export const FlightRequestSubmittedPage = withPageLayout(connect(mapStateToProps)(FlightRequestSubmittedPagePresentational));
